import type {SliderOptionsRange} from '@Components/slider-options';

export const REMOVE_COLOR_MIN_TOLERANCE = 0;
export const REMOVE_COLOR_MIN_DISPLAY_TOLERANCE = 0;
export const REMOVE_COLOR_MAX_TOLERANCE = 1;
export const REMOVE_COLOR_MAX_DISPLAY_TOLERANCE = 100;

export const REMOVE_COLOR_TOLERANCE_RANGE: SliderOptionsRange = {
  min: REMOVE_COLOR_MIN_TOLERANCE,
  max: REMOVE_COLOR_MAX_TOLERANCE,
};

export const REMOVE_COLOR_TOLERANCE_DISPLAY_RANGE: SliderOptionsRange = {
  min: REMOVE_COLOR_MIN_DISPLAY_TOLERANCE,
  max: REMOVE_COLOR_MAX_DISPLAY_TOLERANCE,
};
